/* PAPER ME — 참고용 외화 환산 (2026-09-15)
 *
 * 무엇: 원화 가격 옆에 영어면 달러, 일본어면 엔화를 **참고값으로** 붙인다.
 *   ₩26,000 (approx. $19)   /   ₩26,000 (約 ¥2,983)
 *
 * 🔴 청구는 언제나 원화다. 결제는 Worker 가 만드는 Draft Order 청구서라 스토어 통화(KRW)로 청구되고,
 *    토스·PayPal 모두 원화로 받는다. 실제 외화 청구는 Shopify Payments 가 있어야 하는데 한국 스토어엔 없다.
 *    2026-08-14 에 마켓별 통화를 켰다가 "카드 $19 → 빌더 21,500 KRW → 청구서 ₩21,500" 로 한 주문 안에서
 *    통화가 세 번 바뀌어 원화로 통일했고, 그때 "필요하면 참고용 병기부터" 라고 적어 둔 것이 이 파일이다.
 *    → 그래서 원화를 **바꾸지 않고 옆에 붙인다.** 화면과 결제창이 어긋날 데가 없다.
 *
 * 표기 (대표님 결정 2026-09-15): `~`·`≈` 는 모르는 사람이 많아 **글자로** 쓴다 — 영어 `approx.` · 일본어 `約`.
 *   달러는 $10 미만이면 센트까지($1.49), 그 이상은 정수($19) — "대략"이라는 뜻이 숫자 모양에서도 드러나게.
 *   엔은 원래 소수점이 없다.
 *
 * 환율: Frankfurter v2 (ECB 고시환율 · 무료 · 키 없음 · CORS 허용 · 하루 1회 갱신).
 *   USD 기준으로 KRW·JPY 를 받아 나눈다 — KRW 기준으로 받으면 소수 4자리로 반올림돼(USD 0.00074) 1% 넘게 틀어진다.
 *   브라우저 localStorage 에 12시간 캐시. 못 받으면 아래 FALLBACK(마지막으로 확인한 값)으로 표시한다 —
 *   참고값이라 며칠 묵은 환율이어도 문제없다. 🟡 FALLBACK 은 가끔 갱신할 것(주석의 날짜를 같이).
 *
 * 쓰는 쪽:
 *   - 테마: price.liquid 가 `<span class="pm-fx" data-pm-krw="26000"></span>` 을 비워 두면 여기서 채운다.
 *   - 커스터마이저: `PAPERME_FX.html(krw, LANG)` 로 같은 모양의 span 을 만들어 붙인다.
 *   둘 다 `[data-pm-krw]` 라서, 실시간 환율이 뒤늦게 도착하면 `apply()` 가 **다시 그리지 않고 글자만 바꾼다.**
 *   한국어면 빈 문자열 — 붙는 게 없다.
 */
(function(){
  var KEY='paperme_fx_v1', TTL=12*60*60*1000;
  var API='https://api.frankfurter.dev/v2/rates?base=USD&quotes=KRW,JPY';
  // 1 단위당 원. ECB 2026-09-15 (USD 1,346.04 · JPY 154.36 → 1엔 = 8.72원)
  var FALLBACK={USD:1346, JPY:8.72};
  var CUR={en:'USD', ja:'JPY'};
  var rates=null;

  function langOf(l){
    l=(l||document.documentElement.lang||'').toLowerCase();
    if(l.indexOf('ja')===0)return 'ja';
    if(l.indexOf('en')===0)return 'en';
    return 'ko';
  }
  function read(){
    try{
      var o=JSON.parse(localStorage.getItem(KEY)||'null');
      if(o&&o.t&&(Date.now()-o.t)<TTL&&o.r&&o.r.USD>0&&o.r.JPY>0)return o.r;
    }catch(e){}
    return null;
  }
  function write(r){ try{localStorage.setItem(KEY,JSON.stringify({t:Date.now(),r:r}));}catch(e){} }

  // 환산 글자. 붙일 게 없으면 '' (한국어 · 0원 · 숫자 아님).
  function text(krw, lang){
    var c=CUR[langOf(lang)]; krw=+krw;
    if(!c||!(krw>0))return '';
    var v=krw/((rates||FALLBACK)[c]);
    if(c==='USD'){
      var s=v<10?v.toFixed(2):Math.round(v).toLocaleString('en-US');
      return '(approx. $'+s+')';
    }
    // 「約¥2,983」처럼 붙여 쓰면 읽기 어렵다(대표님 2026-09-18) → 約 뒤에 한 칸.
    return '(約 ¥'+Math.round(v).toLocaleString('ja-JP')+')';
  }
  function html(krw, lang){
    var s=text(krw,lang);
    return s?('<span class="pm-fx" data-pm-krw="'+(+krw)+'">'+s+'</span>'):'';
  }
  function el(krw, lang){
    var s=text(krw,lang); if(!s)return null;
    var sp=document.createElement('span'); sp.className='pm-fx'; sp.setAttribute('data-pm-krw',+krw); sp.textContent=s;
    return sp;
  }
  // 합계 아래 한 줄 각주 — 매 가격마다가 아니라 결제로 이어지는 자리에 한 번.
  function note(lang){
    var l=langOf(lang);
    if(l==='en')return 'Charged in Korean won (₩). Other currencies are estimates.';
    if(l==='ja')return 'お支払いは韓国ウォン（₩）建てです。他通貨の表示は目安です。';
    return '';
  }
  // 이미 붙어 있는 span 들의 글자만 갱신 (환율이 늦게 도착했을 때 · 테마 카드 첫 채움).
  function apply(root, lang){
    var list=(root||document).querySelectorAll('[data-pm-krw]');
    for(var i=0;i<list.length;i++){
      var s=text(list[i].getAttribute('data-pm-krw'),lang);
      list[i].textContent=s;
      list[i].hidden=!s;
    }
  }
  function load(){
    var c=read();
    if(c){rates=c;return;}
    if(typeof fetch!=='function')return;
    fetch(API).then(function(r){return r.json();}).then(function(arr){
      var m={}; (arr||[]).forEach(function(x){m[x.quote]=x.rate;});
      if(m.KRW>0&&m.JPY>0){
        rates={USD:m.KRW, JPY:m.KRW/m.JPY};
        write(rates);
        apply();
      }
    }).catch(function(){ /* 폴백값으로 이미 표시 중 — 조용히 넘어간다 */ });
  }

  // 공통 모양. 두 화면(테마·커스터마이저)의 글자 크기가 달라 em·opacity 로만 정한다.
  // 각주(note) 는 자리마다 글자 크기가 달라 여기서 정하지 않는다 — 쓰는 쪽이 그 자리의 보조 문구와 같게 맞춘다.
  if(!document.getElementById('pm-fx-style')){
    var st=document.createElement('style'); st.id='pm-fx-style';
    st.textContent='.pm-fx{font-size:.82em;font-weight:400;opacity:.72;margin-left:.35em;white-space:nowrap;letter-spacing:0}';
    (document.head||document.documentElement).appendChild(st);
  }

  window.PAPERME_FX={text:text, html:html, el:el, note:note, apply:apply, lang:langOf,
    rates:function(){return rates||FALLBACK;}, live:function(){return !!rates;}};
  load();
  function start(){
    apply();
    // 테마의 필터(facets)·검색 미리보기는 카드 묶음을 통째로 갈아끼운다 — 새로 들어온 조각만 다시 채운다.
    if(typeof MutationObserver==='undefined')return;
    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added=muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n=added[j]; if(n.nodeType!==1)continue;
          if(n.hasAttribute&&n.hasAttribute('data-pm-krw')){apply(n.parentNode);}
          else if(n.querySelector&&n.querySelector('[data-pm-krw]')){apply(n);}
        }
      }
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})();
